var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-menu',{attrs:{"items":_vm.menu,"min-width":"200"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var attrs = ref.attrs;
var on = ref.on;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"ml-2",attrs:{"min-width":"0"}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-account")]),_vm._v(" "),_c('v-badge',{attrs:{"dot":"","value":_vm.isNameUnSet}},[_vm._v("\n        "+_vm._s(_vm.screenName)+"\n      ")])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }